import _ from 'lodash';

import { statusOptionMap } from './DrawRequestDrawerContent.constants';

export const getInitialFormValues = drawRequest => ({
  requestedAmount: _.isNil(drawRequest?.requestedAmount) ? '' : String(drawRequest.requestedAmount),
  approvedAmount: _.isNil(drawRequest?.approvedAmount) ? '' : String(drawRequest.approvedAmount),
  status: drawRequest ? (statusOptionMap[drawRequest.status] ?? null) : null,
  notes: drawRequest?.notes ?? '',
});
